import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from "@angular/http";
import {OrderM} from "../model/order.mobel";
import {PaymentM} from "../model/payment";
import {PurchaseM} from "../model/purchase.model";
import {Util} from "../util/util";

@Injectable()
export class ReceiptService {
  private order: OrderM = new OrderM();
  private payment: PaymentM = new PaymentM();

  headers = new Headers();
  options: RequestOptions;

  constructor(private http: Http) {
    this.headers.append('Content-Type', 'application/json');
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }

  reloadToken() {
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }


  getAll(searchStr: string, status: string, seller_id: number = 0, startDate: string, endDate: string, offset = 0, limit = 30, orderBy = 'desc', sumBy = '') {
    this.reloadToken()
    return this.http.get(`/api/receipt/list?searchStr=${searchStr}&status=${status}&seller_id=${seller_id}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}&orderBy=${orderBy}&sumBy=${sumBy}`, this.options).map(res => res.json());
  }

  getDetail(bill_no: string) {
    this.reloadToken()
    return this.http.get(`/api/receipt/detail/${bill_no}`, this.options).map(res => res.json());
  }

  getDetailById(id: number) {
    this.reloadToken()
    return this.http.get(`/api/receipt/detail/${id}`, this.options).map(res => res.json());
  }

  addReceiptProductByBarcode(barcode:string) {
    this.reloadToken()
    return this.http.get(`/api/receipt/addReceiptProductByBarcode/${barcode}`, this.options).map(res => res.json());
  }

  getBillingInfo(no: string) {
    this.reloadToken()
    return this.http.get(`/api/receipt/detail/${no}`, this.options).map(res => res.json());
  }

  create(purchase: PurchaseM) {
    this.reloadToken()
    return this.http.post(`/api/receipt`, purchase, this.options).map(res => res.json());
  }

  update(purchase: PurchaseM) {
    this.reloadToken()
    return this.http.put(`/api/receipt/detail/${purchase.id}`, purchase, this.options).map(res => res.json());
  }

  updateStatus(id: number, status: string) {
    this.reloadToken()
    return this.http.put(`/api/receipt/status/${id}/${status}`, {}, this.options).map(res => res.json());
  }

  getOrderStatusCount() {
    this.reloadToken()
    return this.http.get(`/api/receipt/getStatusCount`, this.options).map(res => res.json());
  }

  settleReceipt(action: string, receipt_id: number) {
    this.reloadToken()
    return this.http.get(`/api/receipt/settleReceipt/${action}/${receipt_id}`, this.options).map(res => res.json());
  }

  checkPermissionToSetPastDate() {
    this.reloadToken()
    return this.http.get(`/api/receipt/checkPermissionToSetPastDate`, this.options).map(res => res.json());
  }


}



// WEBPACK FOOTER //
// ./src/app/services/receipt.service.ts